import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section id="comprar" className="bg-gradient-to-b from-[#0a0a0a] to-[#111] py-12 px-5 text-center" data-id="element-83">
      <div className="max-w-[800px] mx-auto" data-id="element-84">
        <h2 className="font-oswald text-3xl md:text-[52px] font-bold mb-4 leading-[1.2]" data-id="element-85">
          El momento de prepararte
          <br data-id="element-86" />
          <span className="text-brand-orange" data-id="element-87">es ANTES del apagón.</span>
          <br data-id="element-88" />
          No después.
        </h2>

        <p className="text-lg text-[#ccc] mb-8 leading-[1.7] max-w-[600px] mx-auto" data-id="element-89">
          Cada día que pasás sin un plan es un día que tu familia está expuesta.
          La preparación no es paranoia: es responsabilidad.
        </p>

        <div className="bg-gradient-to-br from-[#111] to-[#1a1a1a] border-2 border-brand-orange rounded-2xl p-5 md:p-8 max-w-[700px] mx-auto shadow-[0_0_40px_rgba(255,87,51,0.2)] mb-6" data-id="element-90">
          <div className="space-y-0" data-id="element-91">
            <div className="flex justify-between items-center py-2.5 border-b border-[#222]" data-id="element-92">
              <span className="text-[#ddd] text-sm md:text-[15px] flex-1 text-left" data-id="element-93">
                📘 El Protocolo Blackout
              </span>
              <span className="text-[#888] line-through text-sm shrink-0" data-id="element-94">
                $197
              </span>
            </div>
            <div className="flex justify-between items-center py-2.5 border-b border-[#222]" data-id="element-95">
              <span className="text-[#ddd] text-sm md:text-[15px] flex-1 text-left" data-id="element-96">
                🩺 + 5 Bonos Exclusivos GRATIS
              </span>
              <span className="text-[#888] line-through text-sm shrink-0" data-id="element-97">
                $425
              </span>
            </div>
          </div>

          <div className="flex justify-between items-center pt-4 mt-2 border-t-2 border-brand-orange" data-id="element-98">
            <span className="font-oswald text-lg md:text-xl font-bold" data-id="element-99">
              TU PRECIO HOY
            </span>
            <span className="font-oswald text-xl md:text-2xl font-bold text-brand-orange" data-id="element-100">
              $19.999
            </span>
          </div>
        </div>

        <CTAButton href="#comprar-ahora" scrollTo="comprar-ahora" showPaymentMethods data-id="element-101">
          🛡️ ACCEDER AL PROTOCOLO BLACKOUT AHORA
        </CTAButton>

        <p className="text-[13px] text-[#888] mt-3" data-id="element-102">
          🔒 Pago 100% seguro · 📧 Acceso inmediato por email · 🛡️ Garantía 30
          días
        </p>
      </div>
    </section>;
}